var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"navbar-admin-login",attrs:{"flat":"","height":"48","color":"transparent"}},[_c('v-container',{staticClass:"navbar-container"},[_c('div',{staticClass:"d-flex align-center brand-click"},[_c('div',{staticClass:"brand-text-group"},[_c('span',{staticClass:"logo-text"},[_vm._v("ELSONIII")])])]),_c('div')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }